export default "__VITE_ASSET__6fFI3r3h__"